import Component from '@glimmer/component';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { HdsIcon } from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import { GEOS } from 'core/utils/constants';

const { EU, US } = GEOS;

const EU_PRODUCTS = [
  {
    icon: 'terraform',
    label: 'nav.project.terraform.header',
  },
  {
    icon: 'waypoint',
    label: 'nav.project.waypoint',
  },
];

const US_PRODUCTS = [
  {
    icon: 'terraform',
    label: 'nav.project.terraform.header',
  },
  {
    icon: 'vagrant',
    label: 'nav.project.vagrant-short',
  },
  {
    icon: 'packer',
    label: 'nav.project.packer',
  },
  {
    icon: 'waypoint',
    label: 'nav.project.waypoint',
  },
  {
    icon: 'vault',
    label: 'nav.project.vault',
  },
  {
    icon: 'boundary',
    label: 'nav.project.boundary',
  },
];

/**
 *
 * `HcpMarketingProducts` renders the HDS flight icon and label for each HCP product defined in the hcpProducts object below.
 *
 *
 * ```
 * <HcpMarketing::Products />
 * ```
 *
 * @class HcpMarketingProducts
 *
 */
export default class HcpMarketingProducts extends Component {
  @service config;

  get deployGeo() {
    return this.config.app?.deployGeo ?? US;
  }

  get hcpProducts() {
    return this.deployGeo === EU ? EU_PRODUCTS : US_PRODUCTS;
  }
  <template>
    <Flex
      @alignItems="center"
      @basis="content"
      @direction="row"
      @gap="md"
      @justifyContent="flex-start"
      @wrap={{true}}
      class="hcp-marketing-products"
      data-test-page-hcp-marketing-products
    >
      {{#each this.hcpProducts as |product|}}
        <span>
          <HdsIcon
            @name="{{product.icon}}-color"
            @size="16"
            @isInline={{true}}
          />
          {{t product.label}}
        </span>
      {{/each}}
    </Flex>
  </template>
}
